import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label }) => (
  <div className="flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-600">
    <span className="text-slate-400">{number}</span>
    <span className="h-px w-10 bg-sky-300" />
    <span>{label}</span>
  </div>
);
